module.exports = __webpack_public_path__ + "static/media/edit.609d0bf2.svg";